import { Box, Divider, Spinner, VStack } from "@chakra-ui/react"
import { Fragment, useState } from "react"
import {
  HomeRegistrationsQueryVariables,
  useHomeRegistrationsQuery
} from "../../api/generated"
import {
  // useHomeCompletedRegistrationVars,
  useHomeSoftArchivedRegistrationVars
} from "../HomeRegistrationQueryVars"
import PathCardContainer from "../components/pathCard/PathCardContainer"
import PathCardListItem from "../components/pathCard/PathCardListItem"
import HomeLibraryBlankSlateTip from "../tips/HomeLibraryBlankSlateTip"
import { filterNestedRegistration, filterRootRegistration } from "../utils"
import HomeAugmentationFilters, {
  HomeAugmentationFilter
} from "./HomeAugmentationFilters"

type HomeLibraryAugmentationFilter = {
  useVariables: () => HomeRegistrationsQueryVariables
} & HomeAugmentationFilter

const filters: HomeLibraryAugmentationFilter[] = [
  {
    key: "soft_archived",
    label: "Set aside",
    icon: "sidebar-bottom",
    iconProps: {
      transform: "rotate(-90deg)"
    },
    useVariables: useHomeSoftArchivedRegistrationVars
  }
  // {
  //   key: "completed",
  //   label: "Completed",
  //   icon: "check",
  //   useVariables: useHomeCompletedRegistrationVars
  // }
]

const RegistrationsList = ({
  variables
}: {
  variables: HomeRegistrationsQueryVariables
}) => {
  const { data, loading } = useHomeRegistrationsQuery({
    variables
  })
  const registrations =
    data?.me?.registrations?.edges?.map((edge) => edge?.node!) || []

  const rootRegistrations = registrations.filter(
    (registration) =>
      // Either filter out all nested registrations...
      filterRootRegistration(registration) ||
      // ...or include a nested registration when no root (parent) is found.
      !registrations.some(
        (rootRegistration) =>
          registration.group!.parent_section_id === rootRegistration.group!.id
      )
  )

  if (loading) {
    return (
      <VStack align="center" w="full" p={2}>
        <Spinner size="lg" color="whiteAlpha.900" />
      </VStack>
    )
  }

  return rootRegistrations.length ? (
    <VStack
      spacing={1}
      position="relative"
      w="full"
      h="full"
      align="flex-start"
      justify="flex-start"
      flexGrow={1}
    >
      {rootRegistrations.map((rootRegistration, i, list) => (
        <Fragment key={rootRegistration.id}>
          <PathCardContainer
            key={rootRegistration.id}
            registration={rootRegistration}
            nestedRegistrations={registrations.filter((registration) =>
              filterNestedRegistration(rootRegistration, registration)
            )}
            PathCardComponent={PathCardListItem}
            p={1}
            borderRadius="20px"
            _hover={{
              bg: "whiteAlpha.300"
            }}
          />
          {i !== list.length - 1 && <Divider />}
        </Fragment>
      ))}
    </VStack>
  ) : (
    <HomeLibraryBlankSlateTip colorScheme="light" />
  )
}

const HomeLibraryAugmentation = () => {
  const [filterKey, setFilterKey] =
    useState<HomeAugmentationFilter["key"]>("soft_archived")
  const filter = filters.find((filter) => filter.key === filterKey)!
  const registrationVariables = filter.useVariables()

  return (
    <VStack w="100%" minH="100%" maxH="100%">
      {/* Hiding filters for now since there's only currently one (set aside). */}
      {false && (
        <HomeAugmentationFilters
          filters={filters}
          value={filterKey}
          onChange={setFilterKey}
        />
      )}
      <Box overflow="auto" w="100%">
        <RegistrationsList variables={registrationVariables} />
      </Box>
    </VStack>
  )
}

export default HomeLibraryAugmentation
